module.exports = "//static.hsappstatic.net/LoginUI/static-1.15632/img/SUI_desktop.svg"